import clsx from 'clsx'
import { FC, PropsWithChildren } from 'react'

type MenuNavItemHighlightedProps = {
  className?: string
}

export const MenuNavItemHighlighted: FC<PropsWithChildren<MenuNavItemHighlightedProps>> = ({
  children,
  className,
}) => {
  return (
    <div className={clsx(className, 'inline-block rounded-sm bg-sg-neon-yellow py-0.5 px-[5px]')}>
      {children}
    </div>
  )
}
